/*eslint-disable */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import { useParams } from "react-router-dom";
import OtrosVehiculosComponent from "../components/vehiculos-detail/otros-vehiculos.component";

const CitaTallerPage: React.FC = () => {
  const { category } = useParams<{ category?: string }>();
  const [visibleHeight, setVisibleHeight] = useState(0);

  useEffect(() => {
    /* lastNewsforCategories().then(function (res: any) {
      let posts: any = [];
      res?.data?.data[0].Categories.forEach((element: any) => {
        element.posts.forEach((pos: any) => {
          pos.category_id = element.category_id;
          pos.category = element.category;
          posts.push(pos);
        });
      });
      
      // Ordenar los posts por fecha de creación de forma descendente
      const sortedPosts = posts.sort((a: any, b: any) => new Date(b.creation_datetime).getTime() - new Date(a.creation_datetime).getTime());
      
      // Obtener los 4 más recientes
      setNewsForCategories(sortedPosts.slice(0, 4));
      setOpportunities(res?.data?.data[0].Opportunities)
    }); */
  }, []);

  return (
    <>
      <Helmet>
        <title>Agendar Cita de Taller Online | Hyundai Colombia</title>
        <meta name="description" content="Programa la cita de mantenimiento preventivo para tu vehículo Hyundai de forma rápida y sencilla en nuestra red de talleres autorizados." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": window.location.origin
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Cita Taller",
                "item": `${window.location.origin}/cita-taller`
              }
            ]
          })}
        </script>
      </Helmet>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Agenda tu Cita en el Taller Hyundai Colombia - Servicio y
          Mantenimiento
        </h1>

        <div className="home-page-mascara"></div>
        <iframe
          src="https://citastaller.hyundaicolombia.co"
          style={{ position: "absolute", display: "initial", border: "0" }}
          className="iframe-cita"
          allowFullScreen
          title="Plataforma de agendamiento para cita de taller de servicio y mantenimiento Hyundai Colombia"
          width="100%"
          height="100%"
        ></iframe>
        {/* <OtrosVehiculosComponent /> */}
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      {/* <FooterLayouts /> */}
    </>
  );
};

export default CitaTallerPage;
